import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';

type CloseConfirmationDialogProps = {
  title: string;
  text: string;
  onClose: () => void;
  proceed: () => void;
};

const CloseConfirmationDialog: FC<CloseConfirmationDialogProps> = ({
  title,
  text,
  onClose,
  proceed,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <ModalNotification
      fullWidth
      size='xs'
      open
      onClose={onClose}
      dialogProps={{
        title,
        content: <Typography variant='body1'>{text}</Typography>,
        actions: [
          {
            label: t('common:cancel'),
            variant: 'text',
            color: 'primary',
            onClick: onClose,
          },
          {
            label: t('common:close'),
            variant: 'contained',
            color: 'primary',
            onClick: proceed,
          },
        ],
      }}
    />
  );
};

export default CloseConfirmationDialog;
